import * as XLSX from 'xlsx';

const ExcelFileCreator = (data, fileName) => {
  // Veriyi bir çalışma kitabına dönüştürme
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  // Dosyayı kaydetme
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export default ExcelFileCreator;